import {iso8601ToDate} from "../../date";

export default function getEndDate(timeSeries: AbstractTimeSeries): Date
{
    if (!timeSeries.isoCodes.length) {
        throw Error("Time series is empty.");
    }
    return iso8601ToDate(timeSeries.isoCodes[timeSeries.isoCodes.length - 1]);
}
